@if (displayAdvisorSimpleSubmitToEwa()) {
    <app-advisor-industrial-business-submit-to-ewa></app-advisor-industrial-business-submit-to-ewa>
} @else if (displayCoordinationIndustrialBusiness()) {
    <app-coordination-industrial-business-submit-to-ewa></app-coordination-industrial-business-submit-to-ewa>
} @else if (displayAdvisorPublicSafetySubmitToEwa()) {
    <app-advisor-public-safety-submit-to-ewa></app-advisor-public-safety-submit-to-ewa>
} @else if (displayPublicSafetyEwa()) {
    <app-public-safety-ewa-submit-to-ewa></app-public-safety-ewa-submit-to-ewa>
} @else if (displayPublicSafetyCustomer()) {
    <app-public-safety-customer-submit-to-ewa></app-public-safety-customer-submit-to-ewa>
} @else if (displayMinimumEwaHandover()) {
    <app-minimum-ewa-handover-submit-to-ewa></app-minimum-ewa-handover-submit-to-ewa>
} @else if (displayRenewalOnlyAndNoticeOfConstruction()) {
    <app-renewal-only-and-notice-of-construction-submit-to-ewa></app-renewal-only-and-notice-of-construction-submit-to-ewa>
}
